import { render, staticRenderFns } from "./buyadd.vue?vue&type=template&id=c85e5018&scoped=true&"
import script from "./buyadd.vue?vue&type=script&lang=js&"
export * from "./buyadd.vue?vue&type=script&lang=js&"
import style0 from "./buyadd.vue?vue&type=style&index=0&id=c85e5018&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85e5018",
  null
  
)

export default component.exports